export default "__VITE_ASSET__A4124OWz__"